import React from 'react'
import { Container } from 'components'

export default ({ UserContentElement }) => (
  <Container>{UserContentElement}</Container>
)
